import { Component, Input, OnInit } from '@angular/core';

import { ExpanderDirective } from '../../directives/expander.directive';
import { ICriteria } from '../../interfaces/ICriteria';

@Component({
  selector: '[appInformationalCriteria]',
  templateUrl: './informational-criteria.component.html'
})
export class InformationalCriteriaComponent extends ExpanderDirective implements OnInit {

  @Input()
  groupId: string;

  @Input()
  informationalCriteria: Pick<ICriteria, 'criteriaLabels' | 'expanderID'>;

  informationalCriteriaExists: boolean;

  ngOnInit(): void {
    this.expanderSelector = `#collapse-${ this.informationalCriteria.expanderID }`;
    this.informationalCriteriaExists = Boolean(this.informationalCriteria.criteriaLabels.length);
  }
}
